<template>
    <div>
      <app-gridview
        v-bind:parentData="{
          tabHeaders: this.dataHeader,
          tabItems: this.dataItems,
          pageTitle: this.pageTitle,
          search: this.search,
          isAdvanceEdit: true,
          isDelete: true,
        }"
        v-on:AdvanceEditItem="advanceEditItemHandler($event)"
        v-on:EditItem="editItemHandler($event)"
        v-on:DeleteItem="deleteItemHandler($event)"
        v-on:NewPressed="newRecordHandler"
      ></app-gridview>
    </div>
  </template>
<script>
import moment from 'moment';
import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('appraisalexerciserecords.appraisalexerciselist'),
      dataHeader: [

        { value: "action", sortable: false, width: "150px" },
        { text: this.$t('apprailsalexercise'), value: "reviewcode", sortable: false, width: "100px" },
        { text: this.$t('pmreviewexercise.exercisedesc'), value: "description", width: "200px" },
        { text: this.$t('columns.type'), value: "formtypetext", width: "100px" },
        { text: this.$t('columns.startdate'), value: "startdate", width: "150px" },
        { text: this.$t('columns.enddate'), value: "enddate", width: "150px" },
        { text: this.$t('pmreviewexercise.assessmenttype'), value: "assessmenttext", width: "200px" },
        { text: this.$t('Setuprankmapset.rankmapset'), value: "pmrankmaptext", width: "200px" },
        { text: this.$t('columns.recordsinsharp'), value: "totalRecords", width: "150px" },
        { text: this.$t('pmreviewexercise.initiatedrecords'), value: "initiated", width: "150px" },
        { text: this.$t('pmreviewexercise.ongoingrecords'), value: "ongoing", width: "200px" },
        { text: this.$t('pmreviewexercise.completedrecords'), value: "completed", width: "200px" },
      ],
      dataItems: [],
      rankMapSet: [],
      rankMapSetList: [],
      assessmentType: [],
      assessmentTypeList: [],
      statusList: [],

      loading: false,
      errMsg: "",
        search: this.$route.params.search,
    };
  },

  methods: {
    async getReviewExercise() {
      const vm = this;
      this.loading = true;

      try {
        const res = await this.$store.dispatch('get', { url: "/reviewexercise/all/summary" });

        vm.dataItems = res.data.rec.map((item) => {
          if (item.startdate) item.startdate = moment(item.startdate).format('YYYY-MM-DD');
          if (item.enddate) item.enddate = moment(item.enddate).format('YYYY-MM-DD');

          if (item.pmrankmapsetid) {
            const rankMap = this.rankMapSetList.find((r) => r.value === item.pmrankmapsetid);
            item.pmrankmaptext = rankMap ? rankMap.text : '';
          }

          if (item.statusid) {
            const status = this.statusList.find((s) => s.value === item.statusid);
            item.status = status ? status.text : '';
          }

          if (item.assessmentid) {
            const assessment = this.assessmentTypeList.find((a) => a.value === item.assessmentid);
            item.assessmenttext = assessment ? assessment.text : '';
          }

          item.formtypetext = item.formtype === 'R' ? 'Rank' : item.formtype === 'G' ? 'Grid' : '';

          item.initiated = Number(item.initiated) || 0;
          item.ongoing = Number(item.ongoing) || 0;
          item.completed = Number(item.completed) || 0;
          item.totalRecords = Number(item.totalRecords) || 0;

          return item;
        });
      } catch (err) {
        vm.errMsg = err;
      } finally {
        vm.loading = false;
      }
    },


    loadStatus() {
        const vm = this;
        return this.$store.dispatch('get', {url: "/reviewexercise/status/all"})
        .then(function (res) {
            vm.status = res.data.rec;
    
            for (let i = 0; i < vm.status.length; i++) {
                vm.statusList.push({
                text: vm.status[i].statusdesc,
                value: vm.status[i].id,
                });
            }
            })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    loadRankMapSet() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/rankmapset/active/all"})
        .then(function (res) {
          vm.rankMapSet = res.data.rec;

          for (let i = 0; i < vm.rankMapSet.length; i++) {
              vm.rankMapSetList.push({
              text: vm.rankMapSet[i].rankmapset,
              value: vm.rankMapSet[i].id,
              });
          }
        })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    loadAssessmentType() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/assessment/all"})
        .then(function (res) {
          vm.assessmentType = res.data.rec;
          for (let i = 0; i < vm.assessmentType.length; i++) {
              vm.assessmentTypeList.push({
              text: vm.assessmentType[i].assessmentcode,
              value: vm.assessmentType[i].id,
              });
          }
        })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    advanceEditItemHandler(item) {
      const advanceItem = this.dataItems.find(dataItem => dataItem.id === item.id);
      this.$router.push({ name: "reviewexercisestaff", params: { id: item.id, item: advanceItem } });
    },


    editItemHandler(item) {
      const advanceItem = this.dataItems.find(dataItem => dataItem.id === item.id);
      this.$router.push({ name: "reviewexerciseedit", params: { id: item.id, item: advanceItem} });
    },

    deleteItemHandler(item){
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('pmreviewexercise.deleteexercise', { code: item.reviewcode }))) {
          this.$store.dispatch('delete', {
              url: "/reviewexercise/" + item.id
          })
          .then((res) => {
          if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
          } else {
              vm.getReviewExercise();
          }
          })
          .catch((err) => {
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "reviewexercisenew" });
    },
  },
  mounted() {
    Promise.all([ this.loadRankMapSet(), this.loadAssessmentType(), this.loadStatus()])
        .then(() => {
            // After loading dependencies, get Review Exercise
            return this.getReviewExercise();
        })
        .then(() => {
            // Once everything is loaded, set loading to false
            this.loading = false;
        })
        .catch((err) => {
            // Handle any errors that occur during the process
            this.isErr = true;
            this.errMsg = err;
            console.error("Error:", err);
        });
  },
};
</script>